import React from "react";
import { withLoanForm } from "../withLoanForm";
import { LivelihoodStep } from "./livelihoodStep";
import { Paper } from "@components/paper/paper";
import ContentWrapper from "@components/contentWrapper";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";

const LivelihoodStepWrap = (props) => {
  const {...rest} = props;
  
  return (
    <Paper>
      <ContentWrapper>
        <MarginLeftRow>
          <PaddingLeftCol>
            <LivelihoodStep {...rest} />
          </PaddingLeftCol>
        </MarginLeftRow>
      </ContentWrapper>
    </Paper>
  );
};

export default withLoanForm(LivelihoodStepWrap);